import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { MathEnabledTextComponent, styleVariables } from '@lib/common';
import { styled } from '@xstyled/styled-components';
import { Checkbox, Space } from 'antd';
import { useState } from 'react';
import { SubmissionBaseQuestion } from './base-question.component';
import { jsx as _jsx } from "react/jsx-runtime";
var AnswerItem = styled(Checkbox)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  flex: 1;\n"])));
var AnswerGroup = styled(Checkbox.Group)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n  img {\n    max-width: 100%;\n  }\n"])));
var AnswerTitle = styled(MathEnabledTextComponent)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  color: ", ";\n\n  p {\n    margin-bottom: 0;\n  }\n"])), styleVariables.colors.gray11);
var AnswerItemLayout = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n"])));
var AnswerContainer = styled(Space)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
export var SubmissionMultipleChoiceQuestion = function SubmissionMultipleChoiceQuestion(props) {
  var question = props.question,
      disabled = props.disabled,
      onSelectedAnswers = props.onSelectedAnswers,
      correctAnswerIds = props.correctAnswerIds;

  var _useState = useState(),
      value = _useState[0],
      setValue = _useState[1];

  var handleSelectAnswerChange = function handleSelectAnswerChange(e) {
    setValue(e);
    onSelectedAnswers === null || onSelectedAnswers === void 0 ? void 0 : onSelectedAnswers(e);
  };

  return /*#__PURE__*/_jsx(SubmissionBaseQuestion, _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx(AnswerGroup, {
      disabled: disabled,
      onChange: handleSelectAnswerChange,
      value: value ? value : correctAnswerIds,
      children: /*#__PURE__*/_jsx(AnswerContainer, {
        direction: "vertical",
        children: question.answers.map(function (a) {
          return /*#__PURE__*/_jsx(AnswerItemLayout, {
            children: /*#__PURE__*/_jsx(AnswerItem, {
              value: a.id.toString(),
              disabled: disabled,
              children: /*#__PURE__*/_jsx(AnswerTitle, {
                value: a.description
              })
            })
          }, a.id.toString());
        })
      })
    })
  }));
};